<!--Site Footer Two Start-->
<footer class="site-footer-two">
    <div class="site-footer-two__shape-1 float-bob-x">
        <img src="assets/images/shapes/site-footer-two-shape-1.png" alt="">
    </div>
    <div class="container">
        <div class="site-footer-two__top">
            <div class="row">



                <div class="col-xl-3 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="400ms">
                    <div class="footer-widget-two__column footer-widget-two__newsletter">
                        <h3 class="footer-widget-two__newsletter-title">Thanvika Enterprises
                        </h3> <br>
                        <form action="https://dreamlayout.mnsithub.com/html/tanspot/main-html/assets/inc/sendemail.php"
                            method="POST" class="footer-widget-two__newsletter-form contact-form-validated">
                            <div class="footer-widget-two__newsletter-form-input-box">
                                <p style="text-align: justify;">Thanvika Enterprises specializes in thermal paper rolls,
                                    barcode labels, price tags, color labels, and customized sticker printing solutions.
                                    We are committed to providing quality products, affordable pricing, and reliable
                                    service for businesses of all sizes.</p>
                            </div>
                            <div class="result"></div>
                        </form>
                        <div class="site-footer-two__social">
                            <a href="https://www.facebook.com/thanvika.enterprises25/"><i class="icon-facebook-app-symbol"></i></a>
                            <a href="https://x.com/thanvikaentps25"><i class="icon-twitter1"></i></a>
                            <a href="https://www.instagram.com/thanvika_enterprises_/"><i class="icon-instagram"></i></a>
                      
                        </div>
                    </div>
                </div>

                <div class="col-xl-2 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="200ms">
                    <div class="footer-widget-two__column footer-widget-two__usefull-link">
                        <div class="footer-widget-two__title-box">
                            <h3 class="footer-widget-two__title">Quick Links</h3>
                        </div>
                        <div class="footer-widget-two__link-box">
                            <ul class="footer-widget-two__link list-unstyled">
                                <li><a routerLink="">Home</a></li>
                                <li><a routerLink="/about">About Us</a></li>
                                <li><a routerLink="/gallery">Gallery</a></li>

                                <li><a routerLink="/contact">Contact</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col-xl-3 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="300ms">
                    <div class="footer-widget-two__column footer-widget-two__services">
                        <div class="footer-widget-two__title-box">
                            <h3 class="footer-widget-two__title">Our Products</h3>
                        </div>
                        <ul class="footer-widget-two__link list-unstyled">
                            <li><a routerLink="/plain-thermal-roll">Thermal Roll</a>
                            </li>
                            <li><a routerLink="/Stickers"> Stickers</a>
                            </li>
                            <li><a routerLink="/wax-ribben">Wax Ribben </a></li>
                      


                        </ul>
                    </div>
                </div>

                <div class="col-xl-4 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="100ms">
                    <div class="footer-widget-two__title-box">
                        <h3 class="footer-widget-two__title">Contact Us</h3>
                    </div>
                    <div class="footer-widget-two__column footer-widget-two__about">
                        <!-- <div class="footer-widget-two__logo">
                                    <a href="index.html"><img src="assets/images/resources/logo-2.png" alt=""></a>
                                </div> -->


                        <p class="footer-widget-two__about-text"> Get in touch with Thanvika Enterprises for premium
                            thermal paper rolls, barcode labels, color labels, and custom sticker printing solutions.
                        </p>
                        <ul class="footer-widget-two__contact list-unstyled">
                            <li>
                                <div class="icon">
                                    <span class="icon-phone-call"></span>
                                </div>
                                <div class="content">
                                    <h5>Contact</h5>
                                    <p><a href="tel:+919994501750"> +91 999 450 1750</a></p>
                                    <p><a href="tel:+919786911750"> +91 978 691 1750</a></p>

                                </div>
                            </li>

                            <li>
                                <div class="icon">
                                    <span class="icon-email"></span>
                                </div>
                                <div class="content">
                                    <h5>Email</h5>
                                    <p>
                                        <a href="mailto:info@thanvikaenterprises.com">
                                            info&#64;thanvikaenterprises.com
                                        </a>
 <a href="mailto:thanvikaenterprises25@gmail.com">
                                            thanvikaenterprises25&#64;gmail.com
                                        </a>
                                    </p>
                                </div>
                            </li>

                            <li>
                                <div class="icon">
                                    <span class="icon-location1"></span>
                                </div>
                                <div class="content">
                                    <h5>Location</h5>
                                    <p>Thanvika Enterprises
                                        <br>
                                        4/350 A Bodipatti,<br> Near Bodipatti Post Office,<br> Udumalaipettai, Tirupur -
                                        642154, <br>Tamil Nadu,
                                        India.
                                    </p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="site-footer-two__bottom">
        <div class="container">
            <div class="site-footer-two__bottom-inner">
                <p class="site-footer-two__bottom-text">© 2026 by <a href="#">Thanvika
                        Enterprises</a> All Rights Reserved.</p>
                <ul class="list-unstyled site-footer-two__bottom-menu">
                    <li><a href="contact.html">Support</a></li>
                    <li><a href="about.html">Terms and Condition</a></li>
                
                </ul>
            </div>
        </div>
    </div>
</footer>
<!--Site Footer Two End-->